export default __webpack_public_path__ + "static/ApercuLAPhil-Regular-710160dab01249742476be65c6d2fd68.woff";